import React from 'react';

function Experience({ id }) {
  return (
    <section id={id}>
      <h2>Experience</h2>
      <div>
        <h3>Senior Salesforce Developer</h3>
        <hr />
        <p>Vortech PCI Group | Jun. 2026 - Present</p>
        <h4>Responsibilities:</h4>
        <ul>
          <li><strong>Enterprise Salesforce DX:</strong> Onboarding into a multi-package Sales Cloud architecture for core banking solutions.</li>
          <li><strong>DevOps &amp; Branching Strategy:</strong> Managing SFDX workflows, CI/CD automation, and shared Scratch Orgs integrated with Azure DevOps.</li>
          <li><strong>Environments &amp; Governance:</strong> Participating in dev alignment, release strategies, and environment provisioning protocols within a strictly regulated financial sector framework.</li>
        </ul>
        <h4>Languages:</h4>
        <p>Apex, JavaScript</p>
        <h4>Frameworks:</h4>
        <p>Sales Cloud, Salesforce DX (SFDX)</p>
        <h4>Software and Tools:</h4>
        <p>Salesforce DX, Node.js, Git, VS Code, Azure DevOps, Jira, Confluence, Shared Scratch Orgs, npm scripts</p>
      </div>
      <div>
        <h3>Senior Salesforce Consultant & Developer</h3>
        <hr />
        <p>Nexion | Mars. 2026 - Jun. 2026</p>
        <h4>Responsibilities:</h4>
        <ul>
          <li>Technical ownership of 3 Salesforce ORGs under a hybrid business model. I acted as the primary technical contact for the client, translating business requirements into scalable solutions.</li>
          <li>Client Consulting & Architecture: Led regular alignment meetings with the client to gather requirements, analyze needs, and draft technical assessment documents (DAE) for approval.</li>
          <li>Core Development: Built custom Lightning Web Components (LWC), advanced Salesforce Flows, and standard/asynchronous Apex logic.</li>
          <li>Large Data Volumes & Admin: Managed user provisioning, custom permission overrides, and executed production data migrations (+1.5M records) using Data Loader and Salesforce Inspector.</li>
          <li>DevOps & Testing: Managed repository branches and Pull Requests via VS Code and GitHub Desktop. Handled deployment troubleshooting, including refactoring Apex Test Classes to ensure successful validation passes.</li>
          <li>Team Mentoring: Acted as the core reference for junior developers, unblocking tasks, reviewing code, and guiding them through their respective ORG environments.</li>
        </ul>
        <h4>Languages:</h4>
        <p>Apex</p>
        <h4>Frameworks:</h4>
        <p>Sales Cloud, Lightning Web Components (LWC), Salesforce Flows & Flow Builder</p>
        <h4>Software and Tools:</h4>
        <p>Sales Cloud Apex, Test Classes, LWC, Salesforce Flows, Flow Builder, SOQL, Salesforce Inspector, Git, VS Code, GitHub Desktop, Jira, Confluence, GitHub</p>
      </div>
      <div>
        <h3>Salesforce Analyst Programmer</h3>
        <hr />
        <p>3MT Galicia Global Service | Jul. 2020 - Jan 2026</p>
        <p><strong>Client:</strong> Guess (Retail)</p>
        <h4>Languages:</h4>
        <p>JavaScript</p>
        <h4>Frameworks:</h4>
        <p>Salesforce Commerce Cloud, JQuery</p>
        <h4>Software and Tools:</h4>
        <p>Node, Einstein, Page Designer, ISML, SCSS, Radial, CyberSource, Cloudinary, Jira, Confluence, GitHub</p>
      </div>
      <div>
        <h3>React Programmer</h3>
        <hr />
        <p>ALDABA | Jan. 2019 - Dec. 2019</p>
        <p><strong>Clients:</strong> Frinsa, Finsa, Estrella Galicia, Ayuntamiento de A Coruña</p>
        <h4>Languages:</h4>
        <p>JavaScript, .NET</p>
        <h4>Frameworks:</h4>
        <p>React.js, Entity Framework Core</p>
        <h4>Software and Tools:</h4>
        <p>Scrum, Fetch API, Visual Code, Postman, GIT, TFS, Azure DevOps Server</p>
      </div>
      <div>
        <h3>JAVA Programmer</h3>
        <hr />
        <p>Altia S.A. | Jun. 2017 - Jan. 2019</p>
        <p><strong>Client:</strong> Inditex</p>
        <h4>Languages:</h4>
        <p>Java</p>
        <h4>Frameworks:</h4>
        <p>SWT</p>
        <h4>Software and Tools:</h4>
        <p>IBM Queue Integration</p>
      </div>
      <div>
        <h3>JavaScript Programmer</h3>
        <hr />
        <p>Comasis | Feb. 2017 - Jun. 2017</p>
        <h4>Languages:</h4>
        <p>JavaScript, HTML, CSS, Powershell</p>
        <h4>Frameworks:</h4>
        <p>JQuery, Bootstrap</p>
        <h4>Software and Tools:</h4>
        <p>SharePoint, SharePoint Designer, SharePoint Color Palette Tool</p>
      </div>
    </section>
  );
}

export default Experience;
